'use client';

import styled, { keyframes } from 'styled-components';

/**
 * 텍스트 Fade-In 애니메이션
 */

// 텍스트 페이드인: 선수 번호, 이름
const titleTextFadeIn = keyframes`
  0%, 10% {  // 처음 10%는 안보이는 상태 (딜레이)
    opacity: 0;
    transform: translateX(-2px);
  }
  20%, 100% {  // 20%~80% 구간에서는 보이게
    opacity: 1;
    transform: translateX(0);
  }
`;

const Container = styled.div<{ $scale: number; $paddingBottom: number }>`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: ${({ $scale, $paddingBottom }) => $scale * $paddingBottom}px;
  text-align: center;

  user-select: none;
  will-change: transform;
`;

const CharWrapper = styled.span`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// 그림자 위 기본 텍스트
const MainChar = styled.span<{ $textColor?: string }>`
  position: relative;
  display: inline-block;
  color: ${({ $textColor }) => $textColor || '#ffffff'};
  opacity: 0;
  z-index: 2;
  animation: ${titleTextFadeIn} 10s ease-in forwards;
  min-width: 0.25em;
`;

// 그림자 텍스트
const ShadowChar = styled.span<{ $textShadow: string }>`
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  color: transparent;
  text-shadow: ${({ $textShadow }) => $textShadow};
  opacity: 0;
  z-index: 1;
  animation: ${titleTextFadeIn} 10s ease-in forwards;
  min-width: 0.25em;
`;

// 전체 기본 텍스트 스타일
const TextBase = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;

  span {
    font-family: inherit;
  }
`;

// 선수 번호
const Number = styled(TextBase)<{
  $scale: number;
  $fontFamily: string;
  $fontWeight: number;
  $numberFontSize: number;
  $numberLineHeight?: number;
}>`
  ${MainChar}, ${ShadowChar} {
    font-size: ${({ $scale, $numberFontSize }) => $scale * $numberFontSize}px;
    font-weight: ${({ $fontWeight }) => $fontWeight};
    font-family: ${({ $fontFamily }) => $fontFamily};
    ${({ $scale, $numberLineHeight }) => $numberLineHeight && `line-height: ${$scale * $numberLineHeight}px;`}
  }
`;

// 선수 이름
const Name = styled(TextBase)<{
  $scale: number;
  $fontFamily: string;
  $fontWeight: number;
  $nameFontSize: number;
  $nameLineHeight?: number;
}>`
  ${MainChar}, ${ShadowChar} {
    text-transform: uppercase; // 대문자로
    font-size: ${({ $scale, $nameFontSize }) => $scale * $nameFontSize}px;
    font-weight: ${({ $fontWeight }) => $fontWeight};
    font-family: ${({ $fontFamily }) => $fontFamily};
    ${({ $scale, $nameLineHeight }) => $nameLineHeight && `line-height: ${$scale * $nameLineHeight}px;`}
  }
`;

const PlayerInfoTextStyled = {
  Container,
  CharWrapper,
  MainChar,
  ShadowChar,
  Number,
  Name,
};

export default PlayerInfoTextStyled;
